import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CasellaConfigService } from '@portal/common';
import { ButtonDirective } from '@portal/ui-common';
import { IconComponent, PhonePipe } from '@shared/ui-shared';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'csl-services-unavailable',
  standalone: true,
  imports: [ButtonDirective, IconComponent, PhonePipe],
  templateUrl: './services-unavailable.component.html',
  styleUrl: './services-unavailable.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'flex flex-col items-center justify-center gap-y-2 self-stretch rounded-3xl bg-yellow-300 pb-2 pl-8 pr-8 pt-2 text-center text-blue-900',
  },
})
export class ServicesUnavailableComponent implements OnInit {
  private readonly casellaConfigService = inject(CasellaConfigService);
  private readonly dialogService = inject(DialogService);
  private readonly destroyRef = inject(DestroyRef);

  contactUsUrl = this.casellaConfigService.config.CONTACT_US_URL;
  contactPhone = this.casellaConfigService.config.CONTACT_PHONE;
  contactEmail = this.casellaConfigService.config.CONTACT_EMAIL;

  @ViewChild('citiesButton', { static: false }) citiesButton!: ElementRef<HTMLButtonElement>;

  openCitiesClick = output<string>();
  contactUsClick = output<string>();

  showStatus = signal(false);
  isCitiesDialogOpen = signal(false);

  ngOnInit() {
    // A small delay is needed to ensure that the screen reader correctly announces the content within the aria-live region.
    setTimeout(() => {
      this.showStatus.set(true);
    }, 100);
  }

  openCitiesDialog() {
    this.isCitiesDialogOpen.set(true);
    this.dialogService
      .openTownsDialog()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          // we need to refocus the cities button after the dialog is closed, and wait a short period to ensure the focus is correctly applied.
          setTimeout(() => {
            this.citiesButton.nativeElement.focus();
          }, 300);
          this.isCitiesDialogOpen.set(false);
        },
        error: () => {
          setTimeout(() => {
            this.citiesButton.nativeElement.focus();
          }, 300);
          this.isCitiesDialogOpen.set(false);
        },
      });

    this.openCitiesClick.emit('these cities');
  }
}
